// extracted by mini-css-extract-plugin
export default {"pageContainer":"settings-page_pageContainer__+T5K5"};